import { FaCube, FaDraftingCompass, FaIndustry, FaPencilRuler, FaCogs, FaTools } from 'react-icons/fa';
import { v4 as uuidv4 } from 'uuid';
import thumb1 from '../../assets/img/service1.jpg';
import thumb2 from '../../assets/img/service2.jpg';
import thumb3 from '../../assets/img/service3.jpg';
import thumb4 from '../../assets/img/service4.jpg';
import thumb5 from '../../assets/img/service5.jpg';
import thumb6 from '../../assets/img/service6.jpg';

const servicesTwoData = [
    {
        id: uuidv4(),
        thumbnail: thumb1,
        icon: <FaDraftingCompass />,
        heading: 'CAD Design & 3D Scanning',
        text: 'Expert computer-aided design and precision 3D scanning services for accurate digital representations of your concepts and existing components.',
    },

    {
        id: uuidv4(),
        thumbnail: thumb2,
        icon: <FaCube />,
        heading: 'Rapid Prototyping',
        text: 'Transform your ideas into physical prototypes quickly and efficiently, enabling faster product development and design validation.',
    },

    {
        id: uuidv4(),
        thumbnail: thumb3,
        icon: <FaPencilRuler />,
        heading: 'Product Design & Development',
        text: 'Comprehensive product design services from initial concept through to production-ready specifications, ensuring functionality and manufacturability.',
    },

    {
        id: uuidv4(),
        thumbnail: thumb4,
        icon: <FaIndustry />,
        heading: 'Industrial Equipment Design',
        text: 'Specialised design solutions for industrial machinery and equipment, optimised for performance, safety, and reliability.',
    },

    {
        id: uuidv4(),
        thumbnail: thumb5,
        icon: <FaCogs />,
        heading: 'Component Manufacturing',
        text: 'Precision manufacturing of industrial components with expert sourcing and plating services to meet your exact specifications.',
    },

    {
        id: uuidv4(),
        thumbnail: thumb6,
        icon: <FaTools />,
        heading: 'Manufacturing Consulting',
        text: 'Strategic consulting for production process optimisation, high-efficiency labour planning, and ISO conformance to enhance your manufacturing operations.',
    },
];

export default servicesTwoData;
